import PortalSection from "../../PortalSection";
import { Helmet } from "react-helmet";

export default function GatesOfOlympus() {
  const curDate = new Date();

  const titlePar = {
    h1: `Play Gates of Olympus in the UK - Reeling in Wins in  ${curDate.getFullYear()}`,
    p: "Gates of Olympus is an electrifying slot game that takes players on an adventurous journey through Greek mythology. With stunning visuals, captivating features, and the potential for huge wins, this game has become a fan-favorite in UK online casinos. Prepare to meet the gods and unlock rewards beyond the clouds!",
  };

  const par1 = {
    id: "par-1",
    h4: "⚡ What is Gates of Olympus?",
    p: `Developed by Pragmatic Play, Gates of Olympus is a 6x5 reel slot game set in the mythological realm of Olympus. Zeus himself stands at the gates, ready to shower players with multipliers, free spins, and massive payouts. The game utilizes a "Pay Anywhere" system, meaning winning combinations can occur anywhere on the reels, making it even more exciting.`,
  };

  const par2 = {
    id: "par-2",
    h4: "💥 Why Is Gates of Olympus So Popular?",
    ul: [
      "High-Potential Payouts: With multipliers and free spins, Gates of Olympus offers significant winning opportunities with each spin.",
      "Engaging Gameplay: The unique Pay Anywhere feature ensures that there's always action, making the game dynamic and thrilling.",
      "Great Graphics: The stunning visuals bring the gods to life, creating an immersive experience that keeps players coming back for more.",
    ],
  };

  const par3 = {
    id: "par-3",
    h4: "🌟 Top Features of Gates of Olympus",
    ul: [
      "Multiplier Feature: Zeus can appear to increase the multiplier with every spin, leading to massive payouts.",
      "Free Spins: Trigger the free spins feature to unlock bonus rounds that increase your chances of hitting big wins.",
      "Tumble Feature: Winning symbols disappear, making way for new symbols to fall into place, creating even more winning chances.",
    ],
    p: "Ready to summon the power of the gods? Play Gates of Olympus now and aim for divine rewards in top UK casinos. Play responsibly and may the gods be on your side!",
  };

  const meta = {
    title: `Gates of Olympus Slot UK ${curDate.getFullYear()}: Features, Wins & Where to Play`,
    description: `Play Gates of Olympus in the UK's top casinos for ${curDate.getFullYear()}. Discover exciting features, spin - triggered bonuses, and tips to reel in big wins. Safe, fun, and fully licensed gameplay at eliteukcasino.com!`,
  };

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <PortalSection />
      <div className="fw-bold w-100 text-bg-dark text-white pt-4 mb-5 mt-2 information">
        <div className="p-4">
          <h1>{titlePar.h1}</h1>
          <p>{titlePar.p}</p>

          <div id={par1.id} className="mt-4">
            <h4>{par1.h4}</h4>
            <p>{par1.p}</p>
          </div>

          <div id={par2.id} className="mt-4">
            <h4>{par2.h4}</h4>
            <ul>
              {par2.ul.map((li, i) => {
                const [title, text] = li.split(":");

                return (
                  <li key={i}>
                    <span className="fw-bold">{title}:</span> {text}
                  </li>
                );
              })}
            </ul>
          </div>

          <div id={par3.id} className="mt-4">
            <h4>{par3.h4}</h4>

            <ul>
              {par3.ul.map((li, i) => {
                const [title, text] = li.split(":");

                return (
                  <li key={i}>
                    <span className="fw-bold">{title}:</span> {text}
                  </li>
                );
              })}
            </ul>
            <p className="mt-3">{par3.p}</p>
          </div>
        </div>
      </div>
    </>
  );
}
